import React from 'react';
import EntireScreenLoadingStyle from './EntireScreenLoadingStyle';
import Loading from '../Loading';

const EntireScreenLoading = () => {
  return (
    <EntireScreenLoadingStyle>
      <Loading />
    </EntireScreenLoadingStyle>
  );
};

export default EntireScreenLoading;
